import { CloseButton, Dialog, Input, Portal, Stack } from '@chakra-ui/react'
import type { FormEvent } from 'react'
import { useState } from 'react'

import { Button } from '@app/components/ui/button'
import { Field } from '@app/components/ui/field'
import { toaster } from '@app/components/ui/toaster'
import { useCustomerCreateMutation } from '@graphql/queries'

const OrganizationCreateButton = ({ children }) => {
  const [loading, setLoading] = useState(false)
  const [, createCustomer] = useCustomerCreateMutation()

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const formData = new FormData(e.currentTarget)
    const formObject = Object.fromEntries(formData.entries())

    setLoading(true)

    await createCustomer({
      input: {
        name: formObject.name as string,
        homepageUrl: formObject.homepageUrl as string
      }
    })
      .then(() => {
        window.location.href = '/welcome'
      })
      .finally(() => {
        setLoading(false)
      })
      .catch((_error) => {
        toaster.create({
          title: 'Organization creation',
          description: 'We were unable to create the organization, please contact support.',
          type: 'error'
        })
      })
  }

  return (
    <>
      <Dialog.Root placement="center">
        <Dialog.Trigger asChild>{children}</Dialog.Trigger>
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content>
              <form onSubmit={handleSubmit}>
                <Dialog.CloseTrigger />
                <Dialog.Header>
                  <Dialog.Title>Create Customer</Dialog.Title>
                </Dialog.Header>
                <Dialog.Body>
                  <Stack gap={4}>
                    <Field label="Customer name" required>
                      <Input name="name" placeholder="Acme Co." />
                    </Field>
                    <Field label="Customer website" required>
                      <Input name="homepageUrl" defaultValue="https://" type="url" />
                    </Field>
                  </Stack>
                </Dialog.Body>
                <Dialog.Footer>
                  <Dialog.ActionTrigger asChild>
                    <Button variant="outline">Cancel</Button>
                  </Dialog.ActionTrigger>
                  <Button type="submit" loading={loading}>
                    Create organization
                  </Button>
                </Dialog.Footer>
                <Dialog.CloseTrigger asChild>
                  <CloseButton size="sm" />
                </Dialog.CloseTrigger>
              </form>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  )
}

export default OrganizationCreateButton
